import React from 'react';
import {Fragment} from "react";
import './menu.css';

class LeftMenu extends React.Component {

    render() {
        const { expanded } = this.props;
        const menuContainerClass = expanded ? 'menuContainer menuContainerVisible' : 'menuContainer';

        return (
            <Fragment>
                <div className={menuContainerClass}>
                    <div className="menu">
                        <ul>
                            <a href='/'><li><b>HOME</b></li></a>
                            <a href="/projects"><li><b>PROJECTS</b></li></a>
                            <a href='/gallery?gallery=badminton'><li><b>BADMINTON PHOTOS</b></li></a>
                            <a href='/gallery'><li><b>GALLERY</b></li></a>
                            <a href='/my_services'><li><b>SERVICES</b></li></a>
                            <a href='/contact'><li><b>CONTACT</b></li></a>
                            <a href='/about'><li><b>ABOUT ME</b></li></a>
                        </ul>
                    </div>
                </div>

                <div className='smallScreensMenuContainer'>

                </div>
            </Fragment>
        );
    }

}

export default LeftMenu;


// WEBPACK FOOTER //
// ./src/screens/leftmenu/index.js